import { call, put, takeLatest } from 'redux-saga/effects'
import { toast } from 'react-toastify'
import * as types from '../../../actions/index.types'
import * as req from '../../../../axios/request/SocietyPortal/InvoiceReqs/InvoiceReqs'

// Get Arrears by Flat
function* getArrearsByFlat(action) {
    try {
        const result = yield call(req.getArrearsByFlatReq, action)
        if (result.success === true) {
            yield put({ type: types.GET_ARREARS_BY_FLAT_SUCCESS, payload: result })
        } else {
            yield put({ type: types.GET_ARREARS_BY_FLAT_FAILURE, message: result?.message })
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.GET_ARREARS_BY_FLAT_FAILURE, message: e?.message })
    }
}

// Get Invoices
function* getInvoices(action) {
    try {
        const result = yield call(req.getInvoicesReq, action)
        if (result.success === true) {
            yield put({ type: types.GET_INVOICES_SUCCESS, payload: result })
        } else {
            yield put({ type: types.GET_INVOICES_FAILURE, message: result?.message })
            toast.error(result?.message || "Failed to fetch invoices")
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.GET_INVOICES_FAILURE, message: e?.message })
        toast.error(e?.response?.data?.message || "Something went wrong")
    }
}

// Get Invoice Details
function* getInvoiceDetails(action) {
    try {
        const result = yield call(req.getInvoiceDetailsReq, action)
        if (result.success === true) {
            yield put({ type: types.GET_INVOICE_DETAILS_SUCCESS, payload: result })
        } else {
            yield put({ type: types.GET_INVOICE_DETAILS_FAILURE, message: result?.message })
            toast.error(result?.message || "Failed to fetch invoice details")
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.GET_INVOICE_DETAILS_FAILURE, message: e?.message })
        toast.error(e?.response?.data?.message || "Something went wrong")
    }
}

// Get Invoice Statistics
function* getInvoiceStatistics(action) {
    try {
        const result = yield call(req.getInvoiceStatisticsReq, action)
        if (result.success === true) {
            yield put({ type: types.GET_INVOICE_STATISTICS_SUCCESS, payload: result })
        } else {
            yield put({ type: types.GET_INVOICE_STATISTICS_FAILURE, message: result?.message })
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.GET_INVOICE_STATISTICS_FAILURE, message: e?.message })
    }
}

// Get Invoices by Flat
function* getInvoicesByFlat(action) {
    try {
        const result = yield call(req.getInvoicesByFlatReq, action)
        if (result.success === true) {
            yield put({ type: types.GET_INVOICES_BY_FLAT_SUCCESS, payload: result })
        } else {
            yield put({ type: types.GET_INVOICES_BY_FLAT_FAILURE, message: result?.message })
            toast.error(result?.message || "Failed to fetch invoices")
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.GET_INVOICES_BY_FLAT_FAILURE, message: e?.message })
        toast.error(e?.response?.data?.message || "Something went wrong")
    }
}

// Get Unpaid Invoices by Flat
function* getUnpaidInvoicesByFlat(action) {
    try {
        const result = yield call(req.getUnpaidInvoicesByFlatReq, action)
        if (result.success === true) {
            yield put({ type: types.GET_UNPAID_INVOICES_BY_FLAT_SUCCESS, payload: result })
        } else {
            yield put({ type: types.GET_UNPAID_INVOICES_BY_FLAT_FAILURE, message: result?.message })
            toast.error(result?.message || "Failed to fetch unpaid invoices")
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.GET_UNPAID_INVOICES_BY_FLAT_FAILURE, message: e?.message })
        toast.error(e?.response?.data?.message || "Something went wrong")
    }
}

// Create Invoice
function* createInvoice(action) {
    try {
        const result = yield call(req.createInvoiceReq, action)
        if (result.success === true) {
            toast.success(result.message || "Invoice created successfully")
            yield put({ type: types.CREATE_INVOICE_SUCCESS, payload: result.data })
            action?.data?.onSuccess?.()
        } else {
            yield put({ type: types.CREATE_INVOICE_FAILURE, message: result?.message })
            toast.error(result?.message || "Failed to create invoice")
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.CREATE_INVOICE_FAILURE, message: e?.message })
        toast.error(e?.response?.data?.message || "Something went wrong")
    }
}

// Update Invoice
function* updateInvoice(action) {
    try {
        const result = yield call(req.updateInvoiceReq, action)
        if (result.success === true) {
            toast.success(result.message || "Invoice updated successfully")
            yield put({ type: types.UPDATE_INVOICE_SUCCESS, payload: result.data })
            action?.data?.onSuccess?.()
        } else {
            yield put({ type: types.UPDATE_INVOICE_FAILURE, message: result?.message })
            toast.error(result?.message || "Failed to update invoice")
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.UPDATE_INVOICE_FAILURE, message: e?.message })
        toast.error(e?.response?.data?.message || "Something went wrong")
    }
}

// Update Draft Invoice
function* updateDraftInvoice(action) {
    try {
        const result = yield call(req.updateDraftInvoiceReq, action)
        if (result.success === true) {
            toast.success(result.message || "Draft invoice updated successfully")
            yield put({ type: types.UPDATE_DRAFT_INVOICE_SUCCESS, payload: result.data })
            action?.data?.onSuccess?.(result.data)
        } else {
            yield put({ type: types.UPDATE_DRAFT_INVOICE_FAILURE, message: result?.message })
            toast.error(result?.message || "Failed to update draft invoice")
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.UPDATE_DRAFT_INVOICE_FAILURE, message: e?.message })
        toast.error(e?.response?.data?.message || "Something went wrong")
    }
}

// Delete Invoice
function* deleteInvoice(action) {
    try {
        const result = yield call(req.deleteInvoiceReq, action)
        if (result.success === true) {
            toast.success(result.message || "Invoice deleted successfully")
            yield put({ type: types.DELETE_INVOICE_SUCCESS, payload: result.data })
            action?.data?.onSuccess?.()
        } else {
            yield put({ type: types.DELETE_INVOICE_FAILURE, message: result?.message })
            toast.error(result?.message || "Failed to delete invoice")
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.DELETE_INVOICE_FAILURE, message: e?.message })
        toast.error(e?.response?.data?.message || "Something went wrong")
    }
}

// Void Invoice
function* voidInvoice(action) {
    try {
        const result = yield call(req.voidInvoiceReq, action)
        if (result.success === true) {
            toast.success(result.message || "Invoice voided successfully")
            yield put({ type: types.VOID_INVOICE_SUCCESS, payload: result.data })
            action?.data?.onSuccess?.()
        } else {
            yield put({ type: types.VOID_INVOICE_FAILURE, message: result?.message })
            toast.error(result?.message || "Failed to void invoice")
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.VOID_INVOICE_FAILURE, message: e?.message })
        toast.error(e?.response?.data?.message || "Something went wrong")
    }
}

// Post Invoice
function* postInvoice(action) {
    try {
        const result = yield call(req.postInvoiceReq, action)
        if (result.success === true) {
            toast.success(result.message || "Invoice posted successfully")
            yield put({ type: types.POST_INVOICE_SUCCESS, payload: result.data })
            action?.data?.onSuccess?.()
        } else {
            yield put({ type: types.POST_INVOICE_FAILURE, message: result?.message })
            toast.error(result?.message || "Failed to post invoice")
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.POST_INVOICE_FAILURE, message: e?.message })
        toast.error(e?.response?.data?.message || "Something went wrong")
    }
}

// Bulk Get Invoice Details
function* bulkInvoiceDetails(action) {
    try {
        const result = yield call(req.bulkInvoiceDetailsReq, action)
        if (result.success === true) {
            yield put({ type: types.BULK_INVOICE_DETAILS_SUCCESS, payload: result })
            action?.data?.onSuccess?.(result.data)
        } else {
            yield put({ type: types.BULK_INVOICE_DETAILS_FAILURE, message: result?.message })
            toast.error(result?.message || "Failed to fetch bulk invoice details")
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.BULK_INVOICE_DETAILS_FAILURE, message: e?.message })
        toast.error(e?.response?.data?.message || "Something went wrong")
    }
}

// Bulk Post Invoices
function* bulkPostInvoices(action) {
    try {
        const result = yield call(req.bulkPostInvoicesReq, action)
        if (result.success === true) {
            const posted = result.data?.posted || [];
            const skipped = result.data?.skipped || [];
            if (posted.length > 0) {
                toast.success(`${posted.length} invoice(s) posted successfully`)
            }
            if (skipped.length > 0) {
                toast.warn(`${skipped.length} invoice(s) skipped`)
            }
            yield put({ type: types.BULK_POST_INVOICES_SUCCESS, payload: result.data })
            action?.data?.onSuccess?.(result.data)
        } else {
            yield put({ type: types.BULK_POST_INVOICES_FAILURE, message: result?.message })
            toast.error(result?.message || "Failed to bulk post invoices")
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.BULK_POST_INVOICES_FAILURE, message: e?.message })
        toast.error(e?.response?.data?.message || "Something went wrong")
    }
}

// Bulk Delete Invoices
function* bulkDeleteInvoices(action) {
    try {
        const result = yield call(req.bulkDeleteInvoicesReq, action)
        if (result.success === true) {
            const deleted = result.data?.deleted || [];
            const skipped = result.data?.skipped || [];
            if (deleted.length > 0) {
                toast.success(`${deleted.length} invoice(s) deleted successfully`)
            }
            if (skipped.length > 0) {
                toast.warn(`${skipped.length} invoice(s) skipped`)
            }
            yield put({ type: types.BULK_DELETE_INVOICES_SUCCESS, payload: result.data })
            action?.data?.onSuccess?.(result.data)
        } else {
            yield put({ type: types.BULK_DELETE_INVOICES_FAILURE, message: result?.message })
            toast.error(result?.message || "Failed to bulk delete invoices")
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.BULK_DELETE_INVOICES_FAILURE, message: e?.message })
        toast.error(e?.response?.data?.message || "Something went wrong")
    }
}

// Bulk Preview Invoices (read-only — per-flat tariff heads + eligibility)
function* bulkPreviewInvoices(action) {
    try {
        const result = yield call(req.bulkPreviewInvoicesReq, action)
        if (result.success === true) {
            yield put({ type: types.BULK_PREVIEW_INVOICES_SUCCESS, payload: result.data })
            action?.data?.onSuccess?.(result.data)
        } else {
            yield put({ type: types.BULK_PREVIEW_INVOICES_FAILURE, message: result?.message })
            toast.error(result?.message || "Failed to preview invoices")
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.BULK_PREVIEW_INVOICES_FAILURE, message: e?.message })
        toast.error(e?.response?.data?.message || "Something went wrong")
    }
}

// Bulk Create Invoices
function* bulkCreateInvoices(action) {
    try {
        const result = yield call(req.bulkCreateInvoicesReq, action)
        if (result.success === true) {
            const created = result.data?.created || [];
            const skipped = result.data?.skipped || [];
            if (created.length > 0) {
                toast.success(`${created.length} invoice(s) created successfully`)
            }
            if (skipped.length > 0) {
                toast.warn(`${skipped.length} invoice(s) skipped`)
            }
            yield put({ type: types.BULK_CREATE_INVOICES_SUCCESS, payload: result.data })
            action?.data?.onSuccess?.(result.data)
        } else {
            yield put({ type: types.BULK_CREATE_INVOICES_FAILURE, message: result?.message })
            toast.error(result?.message || "Failed to bulk create invoices")
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.BULK_CREATE_INVOICES_FAILURE, message: e?.message })
        toast.error(e?.response?.data?.message || "Something went wrong")
    }
}

export default function* InvoiceSaga() {
    yield takeLatest(types.GET_INVOICES, getInvoices)
    yield takeLatest(types.GET_INVOICE_DETAILS, getInvoiceDetails)
    yield takeLatest(types.GET_INVOICE_STATISTICS, getInvoiceStatistics)
    yield takeLatest(types.GET_INVOICES_BY_FLAT, getInvoicesByFlat)
    yield takeLatest(types.GET_UNPAID_INVOICES_BY_FLAT, getUnpaidInvoicesByFlat)
    yield takeLatest(types.CREATE_INVOICE, createInvoice)
    yield takeLatest(types.UPDATE_INVOICE, updateInvoice)
    yield takeLatest(types.UPDATE_DRAFT_INVOICE, updateDraftInvoice)
    yield takeLatest(types.DELETE_INVOICE, deleteInvoice)
    yield takeLatest(types.VOID_INVOICE, voidInvoice)
    yield takeLatest(types.POST_INVOICE, postInvoice)
    yield takeLatest(types.GET_ARREARS_BY_FLAT, getArrearsByFlat)
    yield takeLatest(types.BULK_INVOICE_DETAILS, bulkInvoiceDetails)
    yield takeLatest(types.BULK_POST_INVOICES, bulkPostInvoices)
    yield takeLatest(types.BULK_DELETE_INVOICES, bulkDeleteInvoices)
    yield takeLatest(types.BULK_PREVIEW_INVOICES, bulkPreviewInvoices)
    yield takeLatest(types.BULK_CREATE_INVOICES, bulkCreateInvoices)
}
